function Footer() {
  return (
    <footer className="Footer">
    </footer>
  );
}

export default Footer;
